import CleanButton from '../../../CleanButton/CleanButton';
import IconInCircle from '../../../IconInCircle/IconInCircle';
import Row from '../../../Row/Row';

import leftIcon from './graphics/left.svg?raw';
import rightIcon from './graphics/right.svg?raw';

type CarouselArrowsProps = { onLeft: () => void; onRight: () => void };

const CarouselArrows = ({ onLeft, onRight }: CarouselArrowsProps) => {
    return (
        <Row horizontal="right" space="small">
            <CleanButton onClick={onLeft}>
                <IconInCircle src={leftIcon} variant="brand" size="xlarge" />
            </CleanButton>
            <CleanButton onClick={onRight}>
                <IconInCircle src={rightIcon} variant="brand" size="xlarge" />
            </CleanButton>
        </Row>
    );
};

export default CarouselArrows;
